export const sendMessageOldFormat = (msg: any) => {
  const reactNativeWebView = window.webkit?.messageHandlers?.ReactNativeWebView || window.ReactNativeWebView;
  if (reactNativeWebView) {
    reactNativeWebView.postMessage(msg);
    return;
  }
  window.parent.postMessage(msg, '*');
};

export const isReactNativeWebView = () =>
  typeof window !== 'undefined' && !!(window.webkit?.messageHandlers?.ReactNativeWebView || window.ReactNativeWebView);

export const sendMessage = (data: Record<string, any>) => {
  const reactNativeWebView = window.webkit?.messageHandlers?.ReactNativeWebView || window.ReactNativeWebView;

  if (reactNativeWebView) {
    reactNativeWebView.postMessage(JSON.stringify({ data }));
    return;
  }

  window.parent.postMessage(data, '*');
};

export const useMessageSender = () => {
  return { sendMessage, sendMessageOldFormat };
};
